import { Flag } from './PhoneInput'

// Lingue parlate dall'assistenza (bandiera + nome nel tooltip).
const LANGS = [
  { code: 'IT', label: 'Italiano' },
  { code: 'RO', label: 'Romeno' },
  { code: 'MD', label: 'Moldavo' },
  { code: 'RU', label: 'Russo' },
]

/** Bandiere delle lingue disponibili, con tooltip sopra (hover/focus). */
export function LangFlags() {
  return (
    <span className="lang-flags">
      {LANGS.map((l) => (
        <span key={l.code} className="lang-flag" tabIndex={0} aria-label={l.label}>
          <Flag code={l.code} />
          <span className="lang-tip" role="tooltip">{l.label}</span>
        </span>
      ))}
    </span>
  )
}
